import { IComponentOptions } from "angular";
import { WebJobDetailController } from "./controller";

export const vsComponentName = "webJobDetailComponent";

export const WebJobDetailComponentOptions: IComponentOptions = {
  controller: WebJobDetailController,
  controllerAs: "stateController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    webJobDetail: "<",
  },
};
